<template>
  <nav class="navbar navbar-default">
  <div class="container-fluid">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="@"><img src="@/assets/logoHoriz.png" alt="" style="height:20px"></a>
    </div>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
     
      
      <ul class="nav navbar-nav navbar-right">
        <li v-if="isLoggedIn"><router-link to="/">Dashboard</router-link></li>
         <!--<li v-if="isLoggedIn"><router-link to="/Profile">Dashboard</router-link></li>-->
        <li v-if="!isLoggedIn"><router-link to="/Register">Register</router-link></li>
        <li v-if="!isLoggedIn"><router-link to="/Login">Sign In</router-link></li>
        <li v-if="isLoggedIn"><button id="btnLogout" class="btn btn-default navbar-btn" v-on:click="logout">Logout</button>
        </li>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->
</nav>
</template>

<script>
import firebase from 'firebase'
    export default {
        name:'Navbar',
         data: function(){
          return {
            isLoggedIn : false,
            currentUser : false
          }
        },

        created: function(){
              if (firebase.auth().currentUser) {
                this.isLoggedIn=true;
                this.currentUser=firebase.auth().currentUser.email;
                //alert(this.currentUser);
              }
          },

          methods: { 
            logout: function() {
            firebase.auth().signOut().then(()=>  {
            
            try{
            location.reload()
            //this.$router.push({path:this.$router.path});
            
            //alert('cazzo1')
            //this.$router.push({path:this.$router.path});
            //alert('cazzo2')

            }
            catch(error){
                console.log(error)
            }
            }
            
            )
          }
    }
    }

   



</script>

<style scoped>

#btnLogout{
  margin-top: 8px;
}
.currentuser{
  margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue